var core = module.exports = { version: '2.5.2' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ../~/babel-polyfill/~/core-js/modules/_core.js
// module id = 64
// module chunks = 0